"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var domain_exports = {};
__export(domain_exports, {
  validateDomain: () => validateDomain
});
module.exports = __toCommonJS(domain_exports);
const validatedDomains = /* @__PURE__ */ new Set();
function validateDomain(domain) {
  if (typeof domain !== "string") {
    throw new Error("Invalid storage domain");
  }
  if (!validatedDomains.has(domain)) {
    if (!/^[a-z_][a-z0-9_-]{0,62}$/.test(domain)) {
      throw new Error("Invalid storage domain");
    }
    validatedDomains.add(domain);
  }
  return domain;
}
__name(validateDomain, "validateDomain");
//# sourceMappingURL=domain.js.map
